import * as API from './apiBase';

let baseList = {
    GetSupplier: 'api/InvoiceNew/GetSupplier',
    OCRReport: 'api/InvoiceNew/OCRReport',
    GetCompany: 'api/InvoiceNew/GetCompany',
    DownLoadOCRResultData: 'api/InvoiceNew/DownLoadOCRResultData'
}

/*获取供应商信息 */
export const GetSupplier = () => {
    return API.POST(baseList.GetSupplier, {})
};

/*OCR验真详情数据统计报表 */
export const OCRReport = (SupplierId, DateStart, DateEnd, CompanyCode, language, PageIndex, PageSize) => {
    return API.POST(baseList.OCRReport, {
        SupplierId,
        DateStart,
        DateEnd,
        CompanyCode,
        language,
        PageIndex,
        PageSize
    })
};

/*获取公司 */
export const GetCompany = () => {
    return API.POST(baseList.GetCompany, {})
};

/*下载Excel */
export const DownLoadOCRResultData = (params) => {
    return API.POST(baseList.DownLoadOCRResultData + '?' + params, {}, {responseType: 'blob'})
};
